// extracted by mini-css-extract-plugin
export default {"tabsContainer":"Tabs_tabsContainer__UPxcN","tabButton":"Tabs_tabButton__-Ugx8","active":"Tabs_active__RXc5W"};